// Per-seat, per-month prices in US dollars. Single source of truth shared with the website.

export type SelfServePlanKey = 'basic' | 'pro'

export type PlanPrice = {
  monthly: number
  yearly: number
}

export const SLITE_PLAN_PRICES: Record<SelfServePlanKey, PlanPrice> = {
  basic: { monthly: 12, yearly: 10 },
  pro: { monthly: 25, yearly: 20 },
}
